// Derived from http://taha-sh.com/blog/building-an-awesome-reusable-autocomplete-input-component-in-vue-21-part-two
<template>
    <div class="autocomplete-input">
        <div class="input-group input-border" :class="{ 'orange-border': orangeBorder === true }">
            <input
                    v-model="inputValue"
                    class="form-control input-search"
                    :placeholder="placeholder"
                    @input="onInput($event.target.value)"
                    @keyup.esc="isOpen = false"
                    @blur="isOpen = false"
                    @keydown.down="moveDown"
                    @keydown.up="moveUp"
                    @keydown.enter="select"
            >
            <button v-show="inputValue" @click.prevent="clearInput" class="btn bg-transparent input-search-clear">
                <font-awesome-icon :icon="['far', 'times-circle']"/>
            </button>
        </div>
        <ul id="autocomplete-option-list" :class="{ 'orange-border': orangeBorder === true }" v-show="isOpen && options.length" class="options-list">
            <li v-for="(option, index) in options" :key="index"
                :class="{ 'highlighted': index === highlightedPosition }"
                @mouseenter="highlightedPosition = index"
                @mousedown="select"
            >
                <slot v-bind:option="option">{{ option }}</slot>
            </li>
        </ul>
    </div>

</template>

<script>
  import VueScrollTo from 'vue-scrollto'

  export default {
    name: 'autocomplete',

    props: {
      options: {
        type: Array,
        required: true
      },
      value: {
        type: String,
        required: true
      },
      placeholder: {
        type: String,
        required: false,
        default: 'Search...'
      },
      orangeBorder: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        isOpen: false,
        highlightedPosition: 0,
        inputValue: '',
        scrollToConfig: {
          container: '#autocomplete-option-list',
          easing: 'ease-in',
          x: false,
          y: true
        }
      }
    },

    computed: {
    },

    watch: {
      value: {
        handler (newValue) {
          this.inputValue = newValue
        }
      }
    },

    methods: {
      onInput (value) {
        this.highlightedPosition = 0
        this.isOpen = !!value
        this.$emit('input', value)
      },

      clearInput () {
        this.highlightedPosition = 0
        this.inputValue = ''
        this.isOpen = false
        this.$emit('input', '')
      },

      moveDown () {
        if (!this.isOpen) {
          return
        }
        this.highlightedPosition =
          (this.highlightedPosition + 1) % this.options.length

        this.$nextTick(() => {
          VueScrollTo.scrollTo('.highlighted', 0.2, this.scrollToConfig)
        })
      },

      moveUp () {
        if (!this.isOpen) {
          return
        }
        this.highlightedPosition = this.highlightedPosition - 1 < 0
          ? this.options.length - 1
          : this.highlightedPosition - 1

        this.$nextTick(() => {
          VueScrollTo.scrollTo('.highlighted', 0.2, this.scrollToConfig)
        })
      },

      select () {
        const selectedOption = this.options[this.highlightedPosition]
        this.inputValue = ''
        this.$emit('select', selectedOption)
        this.isOpen = false
      }
    }
  }
</script>

<style scoped>
    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    input {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
    }

    .autocomplete-input {
        position: relative;
        margin-bottom: 1em;
    }

    ul.options-list {
        display: flex;
        flex-direction: column;
        margin-top: 4px;
        border: 1px solid rgb(206, 212, 218);
        border-radius: 5px;
        position: absolute;
        width: 100%;
        overflow: hidden;
        z-index: 25;
        max-height: 350px;
        overflow-y: auto;
        margin-right: 4px;
    }

    ul.options-list li {
        width: 100%;
        flex-wrap: wrap;
        background: white;
        margin: 0;
        border-bottom: 1px solid #eee;
        color: #363636;
        padding: 3px;
        cursor: pointer;
    }

    ul.options-list li.highlighted {
        background: #f8f8f8
    }

    .input-border {
        /* background: white; */
      border: 1px solid rgb(206, 212, 218);
      border-radius: 5px;
    }

    .options-list.orange-border, .orange-border {
      border: 1px solid rgb(255, 70, 0);
    }

    .input-search {
        border: none;
        border-radius: 5px;
        box-shadow: none;
        min-width: 230px;
        margin-right: 4px;
    }

    .input-search:focus {
        box-shadow: none;
        /*box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075),*/
        /*inset 0 0 1px rgba(255, 70, 0, .6);*/
    }

    .input-search-clear {
        margin-left: -40px;
        border-radius: 5px;
        z-index: 100;
        color: rgb(255, 70, 0);
    }
</style>
